import {motion} from "framer-motion";
import Image from "next/image";
import Alerts from "@/components/Alerts";

export default function HeaderBanner({image, alerts}) {
    return (
        <section className={`relative overflow-hidden h-[400px]`}>
            {alerts && alerts.length ? <Alerts alerts={alerts} /> : null}
            <div className={`relative h-full w-full z-n1`}>
                <div className="absolute top-0 left-0 h-full w-full bg-black opacity-40"></div>
                {image?.url || image ? (
                    <Image
                        src={image?.url ? image.url : image}
                        width={1400}
                        height={1200}
                        alt={image?.altText ? image.altText : ''}
                        className={`object-cover w-full h-full`}
                        priority
                    />
                ) : null}
            </div>
        </section>
    )
}